module.exports = __webpack_public_path__ + "1c96e395ef2c6341ef345a3773f5ef8a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/blanket-plum-s.png
// module id = 1237
// module chunks = 0